import { configureStore } from '@reduxjs/toolkit';
import loaderReducer from './loaderSlice';
import admissionFormReducer from './admissionFormSlice';

const store = configureStore({
  reducer: {
    loader: loaderReducer,
    admissionForm: admissionFormReducer
  }
});

export default store;
